import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTranslation } from 'react-i18next';
import { LcaFolderFilter, LcaProductFolderOutSchema } from '../types';
import { getFolderPath } from './folderTree';

interface FolderPathProps {
  folders: LcaProductFolderOutSchema[];
  folderId: number;
  // eslint-disable-next-line no-unused-vars
  onSelect: (folder: LcaFolderFilter) => void;
}

// where the open folder sits in the tree, each level clickable
export default function FolderPath({
  folders,
  folderId,
  onSelect,
}: FolderPathProps) {
  const { t } = useTranslation('lca');
  const path = getFolderPath(folders, folderId);
  if (!path.length) return null;

  const ancestors = path.slice(0, -1);
  const current = path[path.length - 1];

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label={t('folders.title')}
      sx={{ mb: '16px', fontSize: '15px' }}
    >
      <Link
        component="button"
        type="button"
        underline="hover"
        color="inherit"
        onClick={() => onSelect(undefined)}
      >
        {t('folders.allProducts')}
      </Link>
      {ancestors.map((ancestor) => (
        <Link
          key={ancestor.id}
          component="button"
          type="button"
          underline="hover"
          color="inherit"
          onClick={() => onSelect(ancestor.id)}
        >
          {ancestor.name}
        </Link>
      ))}
      <Typography color="text.primary" fontWeight={600} fontSize="inherit">
        {current.name}
      </Typography>
    </Breadcrumbs>
  );
}
